import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { AutenticacionService } from './autenticacion.service';
import { ConstantsService } from './constants.service';
import { ErrorsService } from './tools/errors.service';
import { ValidatorService } from './tools/validator.service';

@Injectable()
export class EmpresasService {

  private service_url;

  constructor(
    private authService: AutenticacionService, 
    private validatorService: ValidatorService, 
    private errorService: ErrorsService,
    private constantsService: ConstantsService, 
    private http: Http,
  ) {
    this.service_url = this.constantsService.apiURL + '/empresas';
   }

  
  public validate(data){
    console.log("validating... ", data);
    
    let error = [];

    if(!this.validatorService.required(data["nombre_comercial"])){
      error["nombre_comercial"] = this.errorService.required;
    }
    if(!this.validatorService.required(data["razon_social"])){
      error["razon_social"] = this.errorService.required;
    }
    if(!this.validatorService.required(data["rfc_empresa"])){
      error["rfc_empresa"] = this.errorService.required;
    }
    if(!this.validatorService.required(data["direccion"])){
      error["direccion"] = this.errorService.required;
    }
    return error;
  }

  getDefaultSchedule() {
    return {
      'nombre_comercial': '',
      'razon_social':'',
      'rfc_empresa':'',
      'direccion': '',
    };
  }

  public registrarEmpresa(data) {
    return this.http.post(this.service_url, data, this.authService.getAuthHeaders());
  }

  public obtenerEmpresas(page = null) {
    if (page) {
      return this.http.get(this.service_url + '?paginate=true&page=' + page , this.authService.getAuthHeaders());
    }
    return this.http.get(this.service_url + '?paginate=true', this.authService.getAuthHeaders());
  }
  //Obtiene todos los productos en general sin paginate
  public getSelect() {
    return this.http.get(this.service_url + '?select=true', this.authService.getAuthHeaders());
  }

  public updateEmpresa(id, data){
    return this.http.put(this.service_url + '?id=' + id, data, this.authService.getAuthHeaders());
  }

  // buscar objeto simple
  search(search, page = null) {
    // buscar con paginacion
    if (page)
      return this.http.get(this.service_url + "?paginate=true&search=" + search + "&page=" + page, this.authService.getAuthHeaders());

    // solo buscar
    return this.http.get(this.service_url + "?paginate=true&search=" + search, this.authService.getAuthHeaders());
  }

  public delete(id) {
    return this.http.delete(this.service_url +'?id='+ id, this.authService.getAuthHeaders());
  }
  
  public writePermission() {
    return true;
    //return this.authService.hasPermission(10, true);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/empresas.service.ts